<template>
    <td-dialog :title="$t(title)" :before-close="dialogLeaveBillClose" :visible.sync="dialogLeaveBillVisible" width="1000px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-container>
            <el-header style="height:100%">
                <el-form :inline="true" :model="leavelBill" ref="leavelBill" class="demo-form-inline">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item :label="$t('pgCommon.MODEL_CAPTION')" prop="workFlowName">
                                <td-input v-model="leavelBill.workFlowName" :disabled="true"></td-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('pgCommon.APPLICANT')" prop="userName" style="margin-left:15px">
                                <td-input v-model="leavelBill.userName" :disabled="isEdit"></td-input>
                            </el-form-item>
                            <el-form-item :label="$t('pgCommon.APPLICATE_DEP')" prop="userDep" style="margin-left:20px">
                                <td-input v-model="leavelBill.userDep" :disabled="isEdit"></td-input>
                            </el-form-item>
                            <el-form-item :label="$t('pgCommon.APPLICANT_CODE')" prop="userNo" style="margin-left:20px">
                                <td-input v-model="leavelBill.userNo" :disabled="isEdit"></td-input>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="24">
                            <el-form-item :label="$t('pgCommon.EVENT_TYPE')" prop="leaveBillType">
                                <td-select :options="leaveBillTypeList" keys="id" text="caption" v-model="leavelBill.leaveBillType" :disabled="isEdit"></td-select>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="24">
                            <el-form-item :label="$t('pgCommon.START_TIME')" prop="startTime">
                                <td-date-time v-model="leavelBill.startTime" :readonly="isEdit"></td-date-time>
                            </el-form-item>
                            <el-form-item :label="$t('pgCommon.END_TIME')" prop="endTime" style="margin-left:20px">
                                <td-date-time v-model="leavelBill.endTime" :readonly="isEdit"></td-date-time>
                            </el-form-item>
                            <el-form-item :label="$t('pgCommon.USE_TIME')" prop="days" style="margin-left:20px">
                                <td-input v-model="leavelBill.days" :disabled="isEdit"></td-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="$t('pgCommon.APPLICANT_REASON')" prop="leaveReason">
                                <td-input type="textarea" v-model="leavelBill.leaveReason" width="797" :rows="4" :disabled="isEdit" maxlength="200"></td-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-header>
        </el-container>
        <span slot="footer" style="text-align:left">
            <td-button type="primary" :loading="loading" @click="btnSubmit(1)">{{ $t('pgCommon.SUBMIT') }}</td-button>
            <td-button type="button" :loading="loading" @click="btnSubmit(0)">{{ $t('pgCommon.RETURN') }}</td-button>
            <td-button type="button" @click="dialogLeaveBillClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from '../assets/api.js';
export default {
    props: ['title', 'dialogLeaveBillVisible', 'isAddData', 'editItem'],
    // 定义变量
    data() {
        return {
            leavelBill: {
                workFlowName: '请假流程测试',
                userName: '',
                userDep: '',
                userNo: '',
                leaveBillType: '',
                workFlowKey: 'workflow-20190302',
                startTime: '',
                endTime: '',
                days: '',
                leaveReason: ''
            },
            loading: false, // 按钮是否为加载状态
            // 操作类型
            leaveBillTypeList: [
                {
                    id: 1,
                    caption: '事假'
                },
                {
                    id: 2,
                    caption: '病假'
                },
                {
                    id: 3,
                    caption: '倒休'
                }
            ],
            isEdit: false
        };
    },
    mounted() {
        if (!this.isAddData) {
            this.btnQuery();
            this.isEdit = true;
        } else {
            this.isEdit = false;
        }
    },
    // 定义并实现方法体
    methods: {
        // btnSubmit(isPass) {
        //     // 有效性验证
        //     this.$refs['leavelBill'].validate(valid => {
        //         if (valid) {
        //             let param = {
        //                 workFlowKey: this.leavelBill.workFlowKey,
        //                 userName: this.leavelBill.userName,
        //                 userDep: this.leavelBill.userDep,
        //                 userNo: this.leavelBill.userNo,
        //                 leaveBillType: this.leavelBill.leaveBillType,
        //                 startTime: this.leavelBill.startTime,
        //                 endTime: this.leavelBill.endTime,
        //                 days: this.leavelBill.days,
        //                 leaveReason: this.leavelBill.leaveReason
        //             };
        //             Api.submitLeaveBill(JSON.stringify(param), response => {
        //                 if (response.status !== this.$common.login.RESPONSE_STATUS) {
        //                     this.$message.error(response);
        //                     return;
        //                 }
        //                 if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
        //                     this.$message.error(response.data.statusMessage);
        //                     this.$log.error('/device/saveDevice', response.data.statusMessage);
        //                     return;
        //                 }
        //                 this.$router.push('/' + 'workflow_role_manager_menu');
        //             });
        //         }
        //     });
        // },
        // 查询流程号对应流程信息
        btnQuery() {
            let param = {
                workFlowCode: this.editItem.processInstanceId
            };
            Api.queryLeaveBillByCode(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('/device/saveDevice', response.data.statusMessage);
                    return;
                }
                // 数据处理
                // this.leavelBill.workFlowKey = response.data.content[0].
                this.leavelBill.userName = response.data.content[0].sUserName;
                this.leavelBill.userDep = response.data.content[0].sDep;
                this.leavelBill.userNo = response.data.content[0].sUserNo;
                this.leavelBill.leaveBillType = 1;
                this.leavelBill.startTime = response.data.content[0].dStartTime;
                this.leavelBill.endTime = response.data.content[0].dEndTime;
                this.leavelBill.days = response.data.content[0].iDays;
                this.leavelBill.leaveReason = response.data.content[0].sReason;
            });
        },
        btnSubmit(isPass) {
            let param = {
                isPass: isPass,
                workFlowCode: this.editItem.executionId
            };
            this.loading = true;
            Api.approvalLeaveBill(JSON.stringify(param), response => {
                this.loading = false;
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    return;
                }
                this.$message({ type: 'success', showClose: true, message: this.$t('审核完成') });
                this.btnCancel();
            });
        },
        btnCancel() {
            this.$emit('dialogLeaveBillClose');
        },
        // 关闭窗口之前需要调用的方法
        dialogLeaveBillClose() {
            this.$emit('dialogLeaveBillClose');
            this.dialogLeaveBillVisible = false;
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
